// ./src/pages/privates/Called/index.tsx
import React, { useState, useCallback, useEffect } from 'react';

import { BiLockOpen } from 'react-icons/bi';
import { FaRoute } from 'react-icons/fa';
import { FiPlus } from 'react-icons/fi';
import { IoReload } from 'react-icons/io5';
// import { TbLockCheck } from 'react-icons';
import { useHistory } from 'react-router-dom';

import {
  CardSimpleEstimate,
  HeaderNavigationPrivate,
  MenuSideBarPrivate,
  SubtitleSecondary,
  ButtonOutline,
} from '@components/index';
import { ConfigRoutes, ConfigStyles } from '@config/index';
import CalledModel from '@models/Called';
import { apiRebox } from '@services/index';
import { formatText } from '@utils/formatters';

import {
  Container,
  ContainerGroup,
  Content,
  Estimates,
  ButtonsOption,
} from './styles';

const Called: React.FC = () => {
  const { push } = useHistory();
  const [totalCalled, setTotalCalled] = useState<number>(0);
  const [totalInstallations, setTotalInstallations] = useState<number>(0);
  const [refresh, setRefresh] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);

  const getCalled = useCallback(async () => {
    try {
      const { data: response } = await apiRebox.get(
        `/called?per_page=1&onlyActive=true`,
      );
      const total = response.data.filter(
        (called: CalledModel) =>
          called.services_id !== '862014cd-5d83-48e4-ab44-e83a4d6b7773',
      ).length;
      setTotalCalled(total);
    } catch (error) {
      console.error('Error ao tentar buscar total de contratos: ', error);
    } finally {
      setLoading(prevState => !prevState);
    }
  }, []);

  const getInstallations = useCallback(async () => {
    try {
      const { data: response } = await apiRebox.get(
        `/called?per_page=1&services_id=862014cd-5d83-48e4-ab44-e83a4d6b7773&onlyActive=true`,
      );
      const { header } = response;
      setTotalInstallations(header.total);
    } catch (error) {
      console.error('Error ao tentar buscar total de contratos: ', error);
    } finally {
      setLoading(prevState => !prevState);
    }
  }, []);

  useEffect(() => {
    setLoading(prevState => !prevState);
    getCalled();
    getInstallations();
  }, [refresh]);
  return (
    <Container>
      <HeaderNavigationPrivate />
      <ContainerGroup>
        <MenuSideBarPrivate />
        <Content>
          <SubtitleSecondary textAlign="start">Chamados</SubtitleSecondary>
          <ButtonsOption>
            <ButtonOutline
              className="btn-new"
              iconLeft={FiPlus}
              onClick={() =>
                push(ConfigRoutes.rebox.privates.called.next.new.path)
              }
            >
              Novo
            </ButtonOutline>
            <ButtonOutline
              className="btn-update"
              loading={loading}
              iconLeft={IoReload}
              onClick={() => setRefresh(prevState => !prevState)}
              style={{ width: '140px' }}
            >
              Atualizar
            </ButtonOutline>
          </ButtonsOption>
          <Estimates>
            <CardSimpleEstimate
              icon={FaRoute}
              iconColor={ConfigStyles.rebox.colors.greenEmerald.main}
              iconSize={28}
              iconOpacity={0.8}
              label={`Total de acionamentos em aberto`}
              value={formatText.numberSeparatedByThousand(totalCalled)}
              linkName={`Listar acionamentos`}
              route={ConfigRoutes.rebox.privates.called.next.drives.path}
            />
            <CardSimpleEstimate
              icon={BiLockOpen}
              iconColor={ConfigStyles.rebox.colors.greenEmerald.main}
              iconSize={28}
              iconOpacity={0.8}
              label={`Total de instalações de GPS em aberto`}
              value={formatText.numberSeparatedByThousand(totalInstallations)}
              linkName={`Listar instalações de GPS`}
              route={ConfigRoutes.rebox.privates.called.next.instal.path}
            />
          </Estimates>
        </Content>
      </ContainerGroup>
    </Container>
  );
};

export default Called;
